import ShipmentRoute from './ShipmentRoute';

export default {
  name: 'ShipmentRoute',
  location: '/shipments',
  component: ShipmentRoute,
};
